import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const Close2Icon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02943 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 0.999998 12 0.999997C5.92487 0.999999 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM16.7071 7.2929C17.0976 7.68342 17.0976 8.31659 16.7071 8.70711L13.4142 11.9999L16.7071 15.2928C17.0976 15.6834 17.0976 16.3165 16.7071 16.707C16.3166 17.0976 15.6834 17.0976 15.2929 16.707L12 13.4142L8.7071 16.707C8.31658 17.0976 7.68341 17.0976 7.29289 16.707C6.90237 16.3165 6.90237 15.6834 7.2929 15.2928L10.5858 11.9999L7.29295 8.70704C6.90243 8.31651 6.90243 7.68335 7.29296 7.29283C7.68348 6.9023 8.31665 6.90231 8.70717 7.29283L12 10.5857L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.2929Z"
    fill="currentColor"
  />,
  "Close2Icon"
);
